export const LEGAL_VERSIONS = {
  terms: '2026-10-30-draft',
  privacy: '2026-10-30-draft',
} as const

export type LegalVersions = typeof LEGAL_VERSIONS
